if (!customElements.get('ingredients-slider')) {
  class IngredientsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.handleCategoryClick = this.handleCategoryClick.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      this.wrapper = this.querySelector('.ingredients-slider__wrapper');
      this.swiperElement = this.querySelector('.ingredients-slider__swiper');

      this.removeEventListener('click', this.handleCategoryClick);
      this.addEventListener('click', this.handleCategoryClick);

      this.initSwiper();
    }

    destroy() {
      this.removeEventListener('click', this.handleCategoryClick);

      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    handleCategoryClick(event) {
      const item = event.target.closest('.ingredients__slider-handle');
      if (!item || !this.wrapper?.contains(item)) return;

      const handle = item.dataset.handle;

      this.wrapper.querySelectorAll('.ingredients__slider-handle.active').forEach((activeHandle) => {
        activeHandle.classList.remove('active');
      });

      const oldActiveItem = this.querySelector('.ingredients-slider__item.active');
      if (oldActiveItem) {
        oldActiveItem.classList.remove('active');
      }

      item.classList.add('active');

      const newActiveItem = this.querySelector(`.ingredients-slider__item[data-handle="${handle}"]`);
      if (newActiveItem) {
        newActiveItem.classList.add('active');
      }
    }

    initSwiper() {
      if (!this.swiperElement) return;

      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      this.slider = new Swiper(this.swiperElement, {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          prevEl: this.swiperElement.querySelector('.arrow-prev'),
          nextEl: this.swiperElement.querySelector('.arrow-next'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        speed: 500,
      });
    }
  }

  customElements.define('ingredients-slider', IngredientsSlider);
}
